var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloudOff = function SvgCloudOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65 54"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.979 24.268c.245-.899.376-1.834.376-2.797 0-5.622-4.38-10.173-9.791-10.173-1.46 0-2.877.327-4.197.981-2.762-4.087-7.37-6.794-12.588-6.794-8.253 0-15.01 6.767-15.37 15.277C3.428 22.58 0 27.492 0 33.097c0 7.23 5.63 13.08 12.589 13.08h32.17c6.181 0 11.19-5.196 11.19-11.627 0-4.269-2.255-8.247-5.97-10.281Zm-5.22 19.002H12.59c-5.412 0-9.792-4.55-9.792-10.173 0-5.16 3.69-9.419 8.48-10.082a12.952 12.952 0 0 1-.087-1.544c0-7.22 5.639-13.08 12.589-13.08 5.271 0 9.782 3.361 11.662 8.139 1.276-1.426 3.094-2.325 5.123-2.325 3.864 0 6.993 3.251 6.993 7.266 0 1.68-.55 3.233-1.477 4.469 4.013.654 7.072 4.26 7.072 8.61 0 4.814-3.759 8.72-8.392 8.72Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.384,
    y: 2.094,
    width: 75.661,
    height: 2.98,
    rx: 0.339,
    transform: "rotate(38.362 3.384 2.094)"
  })));
};
export default SvgCloudOff;